// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VxRs","col":"styles_col__3nFVy","actions":"styles_actions__1SswD","conflict":"styles_conflict__Zpaxg"};